import '@/user/common';
import MoreClick from '@/shared/more_click';

$(() => {
    // 次の10件読み込み
    new MoreClick();
});
